import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { MatIconModule } from '@angular/material/icon';
import { GalaxyAiIconService } from '@vendasta/galaxy/ai-icon';

@Component({
  selector: 'inbox-ai-badge',
  imports: [CommonModule, GalaxyBadgeModule, MatIconModule],
  templateUrl: './Inbox-ai-badge.component.html',
  styleUrl: './inbox-ai-badge.component.scss',
})
export class InboxAiBadgeComponent {
  aiIconService = inject(GalaxyAiIconService);
}
